export const TONES = [
  ["chime", "Chime"],
  ["bell", "Bell"],
  ["ping", "Ping"],
  ["soft", "Soft pop"],
  ["alert", "Urgent alert"],
  ["off", "Silent"],
];

const NOTES = {
  chime: [[880, 0, 0.35, "sine"], [1318.5, 0.12, 0.5, "sine"]],
  bell: [[659.3, 0, 0.9, "triangle"], [1318.5, 0, 0.6, "sine"]],
  ping: [[1567.98, 0, 0.25, "sine"]],
  soft: [[523.25, 0, 0.18, "sine"], [783.99, 0.09, 0.22, "sine"]],
  alert: [[987.77, 0, 0.14, "square"], [987.77, 0.2, 0.14, "square"], [1318.5, 0.4, 0.22, "square"]],
};

let ctx;
export function playTone(name) {
  const notes = NOTES[name];
  if (!notes) return;
  ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  const t0 = ctx.currentTime;
  notes.forEach(([freq, at, len, type]) => {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = type;
    o.frequency.value = freq;
    const vol = type === "square" ? 0.06 : 0.22;
    g.gain.setValueAtTime(0.0001, t0 + at);
    g.gain.exponentialRampToValueAtTime(vol, t0 + at + 0.015);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + at + len);
    o.connect(g).connect(ctx.destination);
    o.start(t0 + at);
    o.stop(t0 + at + len + 0.05);
  });
}
